import { useFormContext } from 'react-hook-form'
import { Input } from '@/components/ui/input'
import { PostFormData } from '../types'

export function FormUrlField() {
  const { register, formState } = useFormContext<PostFormData>()
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">URL *</label>
      <Input
        {...register('url')}
        type="url"
        placeholder="https://exemplo.com"
      />
      {formState.errors.url && (
        <p className="text-sm text-red-500">{formState.errors.url.message}</p>
      )}
    </div>
  )
}
